// src/msalConfig.ts
import { LogLevel, Logger, PublicClientApplication } from "@azure/msal-browser";
import logger from "utils/logger";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID!,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/microsoft`,
    navigateToLoginRequestUrl: false,
  },

  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
});

msalInstance.setLogger(
  new Logger({
    loggerCallback: (level, message, containsPii) => {
      if (containsPii) return;
      switch (level) {
        case LogLevel.Error:
          logger.error(message);
          break;
        case LogLevel.Warning:
          logger.warn(message);
          break;
        case LogLevel.Info:
          logger.info(message);
          break;
        case LogLevel.Verbose:
          logger.debug(message);
          break;
      }
    },
    piiLoggingEnabled: false,
    logLevel: LogLevel.Info, // 👈 adjust verbosity here
  })
);

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};
